import type { Placement } from '@floating-ui/dom';

type TooltipPlacementKey = 'TOP' | 'BOTTOM' | 'LEFT' | 'RIGHT';

export const HEADING_LOCATIONS = {
  TOP: 'Top',
  BOTTOM: 'Bottom'
} as const;

export const TOOLTIP_PLACEMENTS: Record<TooltipPlacementKey, Placement> = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};

interface TooltipConfig {
  OFFSET: number;
  PLACEMENTS: Record<TooltipPlacementKey, Placement>;
}

export const TOOLTIP: TooltipConfig = {
  OFFSET: 35,
  PLACEMENTS: TOOLTIP_PLACEMENTS
};

export interface TooltipProductI {
  id: number;
  sku: string;
  name: string;
  plp_description: string;
  price: string;
  thumbnailUrl: string;
  url: string;
  hasStock: boolean;
  replenishable: boolean;
}
